import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TesteService } from 'src/app/services/teste.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-alterar',
  templateUrl: './alterar.component.html',
  styleUrls: ['./alterar.component.scss']
})

export class AlterarComponent implements OnInit {

  file1:string;
  file2:string;
  file4:string;
  file8:string;
fileToUpload: File | null = null;
cpf: string;
form: FormGroup;
comboCursos = [];
comboInstituicoes = [];
comboConselhos = [];
mensa: string;
mcpf: string;
mnome: string;
mnasc: string;
marea: string;
mcurso: string;
midgenero: string;
memail: string;
mbairro: string;
mcidade: string;
midinstituicao: string;
midconselho: string;
mnaturalidade: string;
mnacionalidade: string;
mendereco: string;
mcomplemento: string;
muf: string;
mfixo: string;
mcelular: string;
mnumconselho: string;
mdtconselho: string;
midentidade: string;
morgaoid: string;
mcep: string;

mtituloeleitor: string;
mufeleitor: string;
mzonaeleitor: string;
mseceleitor: string;
mcertmilitar: string;
morgmilitar: string;
msecmilitar: string;
midetinia: string;
mgruposangue: string;
mtiposangue: string;
mbanco: string;
magencia: string;
mconta: string;
mpai:string;
mmae:string;
mdtid: string;
mstatus: string;
m_cep : string;
m_endereco: string;
m_bairro : string;
m_cidade : string;
m_uf : string;
mclassificacao: string;
mcodturma: string;
mdataap: string;
mhoraap: string;
m_filename: string;
m_filename1: string;
m_filename2: string;
m_filename4: string;
m_filename8: string;
inscricao: any;
caminhoArquivosUpload:string;

formData = new FormData();

  constructor( private fb: FormBuilder, private router: Router, private testeService: TesteService) {

  }

  ngOnInit(): void {

    this.initForm();
    
    this.inscricao = this.testeService.pub_inscricao;
    this.testeService.pub_cpf=this.inscricao.cpf;
    console.log(this.inscricao);
    
    console.log("1======> ",this.testeService.ppub_numero);
    console.log("2======> ",this.testeService.ppub_processo);
    console.log("3======> ",this.testeService.ppub_sei);
    console.log("4======> ",this.testeService.ppub_data);
    console.log("5======> ",this.testeService.ppub_horario);
    console.log("6======> ",this.testeService.ppub_modalidade);
    console.log("7======> ",this.testeService.ppub_agrupamento);
    console.log("8======> ",this.testeService.ppub_titulo);
    console.log("9======> ",this.testeService.ppub_descricao);
    console.log("10=====> ",this.testeService.ppub_suspensa);


    
      this.form.get("numero").setValue(this.testeService.ppub_numero);
      this.form.get("processo").setValue(this.testeService.ppub_processo);
      this.form.get("sei").setValue(this.testeService.ppub_sei);
      this.form.get("data").setValue(this.testeService.ppub_data);
      this.form.get("horario").setValue(this.testeService.ppub_horario);
      this.form.get("modalidade").setValue(this.testeService.ppub_modalidade);
      this.form.get("agrupamento").setValue(this.testeService.ppub_agrupamento);
      this.form.get("titulo").setValue(this.testeService.ppub_titulo);
      this.form.get("descricao").setValue(this.testeService.ppub_titulo);  //ppub_descricao
      this.form.get("suspensa").setValue(this.testeService.ppub_suspensa);
      this.form.get("noar").setValue(this.testeService.ppub_noar);


 
      this.m_filename1= this.testeService.ppub_sei + ".PDF"; //254100046644202371SEI.PDF";
      this.m_filename2= this.inscricao.cpf+"CPF.PDF";
      this.m_filename4= this.inscricao.cpf+"RES.PDF";
      this.m_filename8= this.inscricao.cpf+"HIS.PDF";



    var str = this.testeService.ppub_sei;
    this.file1 = str.substring(0,5) + str.substring(6,12) + str.substring(13,17) + str.substring(18,20) + "SEI.PDF";
    this.m_filename1= str.substring(0,5) + str.substring(6,12) + str.substring(13,17) + str.substring(18,20) + "SEI.PDF";

    this.file1 = this.testeService.ppub_sei + ".PDF"
    this.m_filename1= this.testeService.ppub_sei + ".PDF"


    var variavel=this.testeService.ppub_sei;
    var variavel = variavel.replace('.', ''); 
    var variavel = variavel.replace('/', ''); //remove UMA barra
    var variavel = variavel.replace('-', ''); //remove UM traço
    var variavel = variavel.replace('/', ''); //remove OUTRA barra
    var variavel = variavel.replace('SEI', ''); //remove UM SEI
    this.file1 = variavel + "SEI.PDF";
    this.m_filename1= variavel + "SEI.PDF";


    //this.file1 = "10123/71743537700/71743537700IDE.pdf" ;
    //this.file1 = "http://incanet/portaladministrativo/sghi.pamodsisaapi/documentos/10123/71743537700/71743537700ide.pdf";
    this.file2 = this.inscricao.cpf+"CPF";
    this.file4 = this.inscricao.cpf+"RES";
    this.file8 = this.inscricao.cpf+"HIS";

    this.caminhoArquivosUpload= `${environment.caminhoArquivosUpload}`
    //this.caminhoArquivosUpload= "http://incanet/portaladministrativo/sghi.pamodsisaapi/documentos/10123/71743537700/";
    //this.caminhoArquivosUpload= "c:/temp/";
  }


  initForm() {
    this.form = this.fb.group({
      numero: '',
      processo: '',
      sei: '',
      data: '',
      horario: '',
      modalidade: '',
      agrupamento: '',
      titulo: '',
      descricao: '',
      suspensa: '',
      orgaoid:'',
      Nasc: '',
      IdSexo: '',
      Idarea: '',
      Idmodalidade: '',
      nacionalidade: '',
      naturalidade: '',
      conselho: '',
      dtconselho: '',
      numconselho: '',
      cep: '',
      endereco: '',
      complemento: '',
      bairro: '',
      cidade: '',
      uf: '',
      fixo:'',
      celular: '',
      email: '',
      status: '',
      file1: '',
      file11: '',
      file12: '',
      file13: '',
      file14: '',
      file15: '',
      file16: '',
      file17: '',
      file18: '',
      Rh: '',
      Grupo: '',
      Etinia: '',
      Seriemilitar: '',
      Orgmilitar:'',
      Nummilitar:'',
      Secaotitulo:'',
      Zonatitulo:'',
      Uftitulo:'',
      Numtitulo:'',
      pai:'',
      mae:'',
      banco:'',
      agencia:'',
      conta:'',
      classificacao:'',
      codturma:'',
      dataap: '',
      horaap: '',
      noar:''

    });
  }



  alteraStatus() {


    if(confirm("Confirma a Modificação de Status?")){
      //grava inscricao
      console.log('Altera status => ',this.form.get('cpf').value, this.form.get('status').value);
      this.testeService.alteraStatus(this.form.get('cpf').value, this.form.get('status').value );

      if(confirm("Confirma o Envio de E-mail?")){
        if (this.form.get('status').value=='SOLICITADO'){
          const reme = "teste@inca.gov.br";
          const desti = "jose.pacheco@ctis.com.br";
          const titulo = "Confirmação de pre-inscrição";
          const mens = "Confirmação de processo de pre-inscricao";
          // Texto de confirmação avisando data e hora de apresentação
          this.testeService.enviaEmail(reme, desti, titulo, mens);

        }
      }

    }

    // navega para a tela de login
    this.router.navigate(['/administra']);
  }

  get formControls() {
    return this.form.controls;
  }


  enviarAlteracao() {


   // this.form.controls.status.setValue('1');
   // this.form.controls.dtid.setValue(null);
   //this.form.controls.Nasc.setValue(null);
   //this.testeService.pub_vez = '1';

    if (this.criticaCampos())
    {

        if(confirm("Confirma a Gravação da Alteração?")){
          //grava inscricao
          this.testeService.incluirEdital(this.form.value);   /////   alterarEdital(this.form.value); 

        }

        // navega para a tela de login
        this.router.navigate(['menu']);
   }else{
        // permanece na pagina
   }
  }







  criticaCampos()
  {
    this.mensa ='';
    if (this.form.get('numero').value==''){
      this.mensa = 'Numero em branco';
      return false;
    }
    return true;
  }

  fileUp(id: string, caminho: string, arquivo: string){

  
    // navega para a tela de upload
    this.testeService.pubtip = id;


    var variavel=this.form.get('sei').value;
    var variavel = variavel.replace('.', ''); 
    var variavel = variavel.replace('/', ''); //remove UMA barra
    var variavel = variavel.replace('-', ''); //remove UM traço
    var variavel = variavel.replace('/', ''); //remove OUTRA barra
    var variavel = variavel.replace('SEI', ''); //remove UM SEI
    this.file1 = variavel + "SEI.PDF";
    this.m_filename1= variavel + "SEI.PDF";


   // this.m_filename1 = this.form.get('sei').value + ".PDF";
    this.testeService.pub_sei = this.m_filename1;




    this.router.navigate(['/upload']);
    this.form.get("file1").setValue(this.testeService.pubdoc);

  }

  fileDelete(id: string, caminho: string, arquivo: string){

  }



  retorna(){
    // navega para a tela de login
    this.router.navigate(['/menu']);

  }
}

